module.exports = __webpack_public_path__ + "static/media/Back_jeux.e64a820c.jpg";